const compatModules = {};import * as Mod1 from "./discourse/components/admin-provider-manager";
compatModules["discourse/components/admin-provider-manager"] = Mod1;

export * as discourse$components$admin__provider__manager$$__module from "./discourse/components/admin-provider-manager";
export {
default as discourse$components$admin__provider__manager$$default
} from "./discourse/components/admin-provider-manager";
import * as Mod2 from "./discourse/components/key-value-builder";
compatModules["discourse/components/key-value-builder"] = Mod2;

export * as discourse$components$key__value__builder$$__module from "./discourse/components/key-value-builder";
export {
default as discourse$components$key__value__builder$$default
} from "./discourse/components/key-value-builder";
import * as Mod3 from "./discourse/components/proxyviews-calculator";
compatModules["discourse/components/proxyviews-calculator"] = Mod3;

export * as discourse$components$proxyviews__calculator$$__module from "./discourse/components/proxyviews-calculator";
export {
default as discourse$components$proxyviews__calculator$$default
} from "./discourse/components/proxyviews-calculator";
import * as Mod4 from "./discourse/components/proxyviews-compare";
compatModules["discourse/components/proxyviews-compare"] = Mod4;

export * as discourse$components$proxyviews__compare$$__module from "./discourse/components/proxyviews-compare";
export {
default as discourse$components$proxyviews__compare$$default
} from "./discourse/components/proxyviews-compare";
import * as Mod5 from "./discourse/components/proxyviews-directory-browser";
compatModules["discourse/components/proxyviews-directory-browser"] = Mod5;

export * as discourse$components$proxyviews__directory__browser$$__module from "./discourse/components/proxyviews-directory-browser";
export {
default as discourse$components$proxyviews__directory__browser$$default
} from "./discourse/components/proxyviews-directory-browser";
import * as Mod6 from "./discourse/components/proxyviews-provider-detail";
compatModules["discourse/components/proxyviews-provider-detail"] = Mod6;

export * as discourse$components$proxyviews__provider__detail$$__module from "./discourse/components/proxyviews-provider-detail";
export {
default as discourse$components$proxyviews__provider__detail$$default
} from "./discourse/components/proxyviews-provider-detail";
import * as Mod7 from "./discourse/components/proxyviews-svg-chart";
compatModules["discourse/components/proxyviews-svg-chart"] = Mod7;

export * as discourse$components$proxyviews__svg__chart$$__module from "./discourse/components/proxyviews-svg-chart";
export {
default as discourse$components$proxyviews__svg__chart$$default
} from "./discourse/components/proxyviews-svg-chart";
import * as Mod8 from "./discourse/controllers/admin-plugins-proxyviews-directory";
compatModules["discourse/controllers/admin-plugins-proxyviews-directory"] = Mod8;

export * as discourse$controllers$admin__plugins__proxyviews__directory$$__module from "./discourse/controllers/admin-plugins-proxyviews-directory";
export {
default as discourse$controllers$admin__plugins__proxyviews__directory$$default
} from "./discourse/controllers/admin-plugins-proxyviews-directory";
import * as Mod9 from "./discourse/controllers/admin-plugins/proxyviews-directory";
compatModules["discourse/controllers/admin-plugins/proxyviews-directory"] = Mod9;

export * as discourse$controllers$admin__plugins$proxyviews__directory$$__module from "./discourse/controllers/admin-plugins/proxyviews-directory";
export {
default as discourse$controllers$admin__plugins$proxyviews__directory$$default
} from "./discourse/controllers/admin-plugins/proxyviews-directory";
import * as Mod10 from "./discourse/initializers/directory-admin";
compatModules["discourse/initializers/directory-admin"] = Mod10;

export * as discourse$initializers$directory__admin$$__module from "./discourse/initializers/directory-admin";
export {
default as discourse$initializers$directory__admin$$default
} from "./discourse/initializers/directory-admin";
import * as Mod11 from "./discourse/proxyviews-directory-route-map";
compatModules["discourse/proxyviews-directory-route-map"] = Mod11;

export * as discourse$proxyviews__directory__route__map$$__module from "./discourse/proxyviews-directory-route-map";
export {
default as discourse$proxyviews__directory__route__map$$default
} from "./discourse/proxyviews-directory-route-map";
import * as Mod12 from "./discourse/routes/admin-plugins-proxyviews-directory";
compatModules["discourse/routes/admin-plugins-proxyviews-directory"] = Mod12;

export * as discourse$routes$admin__plugins__proxyviews__directory$$__module from "./discourse/routes/admin-plugins-proxyviews-directory";
export {
default as discourse$routes$admin__plugins__proxyviews__directory$$default
} from "./discourse/routes/admin-plugins-proxyviews-directory";
import * as Mod13 from "./discourse/routes/admin-plugins/proxyviews-directory";
compatModules["discourse/routes/admin-plugins/proxyviews-directory"] = Mod13;

export * as discourse$routes$admin__plugins$proxyviews__directory$$__module from "./discourse/routes/admin-plugins/proxyviews-directory";
export {
default as discourse$routes$admin__plugins$proxyviews__directory$$default
} from "./discourse/routes/admin-plugins/proxyviews-directory";
import * as Mod14 from "./discourse/routes/proxyviews-affiliate-disclosure";
compatModules["discourse/routes/proxyviews-affiliate-disclosure"] = Mod14;

export * as discourse$routes$proxyviews__affiliate__disclosure$$__module from "./discourse/routes/proxyviews-affiliate-disclosure";
export {
default as discourse$routes$proxyviews__affiliate__disclosure$$default
} from "./discourse/routes/proxyviews-affiliate-disclosure";
import * as Mod15 from "./discourse/routes/proxyviews-calculator";
compatModules["discourse/routes/proxyviews-calculator"] = Mod15;

export * as discourse$routes$proxyviews__calculator$$__module from "./discourse/routes/proxyviews-calculator";
export {
default as discourse$routes$proxyviews__calculator$$default
} from "./discourse/routes/proxyviews-calculator";
import * as Mod16 from "./discourse/routes/proxyviews-compare";
compatModules["discourse/routes/proxyviews-compare"] = Mod16;

export * as discourse$routes$proxyviews__compare$$__module from "./discourse/routes/proxyviews-compare";
export {
default as discourse$routes$proxyviews__compare$$default
} from "./discourse/routes/proxyviews-compare";
import * as Mod17 from "./discourse/routes/proxyviews-directory";
compatModules["discourse/routes/proxyviews-directory"] = Mod17;

export * as discourse$routes$proxyviews__directory$$__module from "./discourse/routes/proxyviews-directory";
export {
logoFor as discourse$routes$proxyviews__directory$$logoFor,
mapProvider as discourse$routes$proxyviews__directory$$mapProvider,
DEFAULT_DIRECTORY_PARAMS as discourse$routes$proxyviews__directory$$DEFAULT_DIRECTORY_PARAMS,
fetchProviders as discourse$routes$proxyviews__directory$$fetchProviders,
default as discourse$routes$proxyviews__directory$$default
} from "./discourse/routes/proxyviews-directory";
import * as Mod18 from "./discourse/routes/proxyviews-methodology";
compatModules["discourse/routes/proxyviews-methodology"] = Mod18;

export * as discourse$routes$proxyviews__methodology$$__module from "./discourse/routes/proxyviews-methodology";
export {
default as discourse$routes$proxyviews__methodology$$default
} from "./discourse/routes/proxyviews-methodology";
import * as Mod19 from "./discourse/routes/proxyviews-provider";
compatModules["discourse/routes/proxyviews-provider"] = Mod19;

export * as discourse$routes$proxyviews__provider$$__module from "./discourse/routes/proxyviews-provider";
export {
default as discourse$routes$proxyviews__provider$$default
} from "./discourse/routes/proxyviews-provider";
import * as Mod20 from "./discourse/routes/proxyviews-vendor-dashboard";
compatModules["discourse/routes/proxyviews-vendor-dashboard"] = Mod20;

export * as discourse$routes$proxyviews__vendor__dashboard$$__module from "./discourse/routes/proxyviews-vendor-dashboard";
export {
default as discourse$routes$proxyviews__vendor__dashboard$$default
} from "./discourse/routes/proxyviews-vendor-dashboard";
import * as Mod21 from "./discourse/services/provider-admin";
compatModules["discourse/services/provider-admin"] = Mod21;

export * as discourse$services$provider__admin$$__module from "./discourse/services/provider-admin";
export {
default as discourse$services$provider__admin$$default
} from "./discourse/services/provider-admin";
import * as Mod22 from "./discourse/templates/admin-plugins-proxyviews-directory";
compatModules["discourse/templates/admin-plugins-proxyviews-directory"] = Mod22;

export * as discourse$templates$admin__plugins__proxyviews__directory$$__module from "./discourse/templates/admin-plugins-proxyviews-directory";
export {
default as discourse$templates$admin__plugins__proxyviews__directory$$default
} from "./discourse/templates/admin-plugins-proxyviews-directory";
import * as Mod23 from "./discourse/templates/admin-plugins/proxyviews-directory";
compatModules["discourse/templates/admin-plugins/proxyviews-directory"] = Mod23;

export * as discourse$templates$admin__plugins$proxyviews__directory$$__module from "./discourse/templates/admin-plugins/proxyviews-directory";
export {
default as discourse$templates$admin__plugins$proxyviews__directory$$default
} from "./discourse/templates/admin-plugins/proxyviews-directory";
import * as Mod24 from "./discourse/templates/proxyviews-affiliate-disclosure";
compatModules["discourse/templates/proxyviews-affiliate-disclosure"] = Mod24;

export * as discourse$templates$proxyviews__affiliate__disclosure$$__module from "./discourse/templates/proxyviews-affiliate-disclosure";
export {
default as discourse$templates$proxyviews__affiliate__disclosure$$default
} from "./discourse/templates/proxyviews-affiliate-disclosure";
import * as Mod25 from "./discourse/templates/proxyviews-calculator";
compatModules["discourse/templates/proxyviews-calculator"] = Mod25;

export * as discourse$templates$proxyviews__calculator$$__module from "./discourse/templates/proxyviews-calculator";
export {
default as discourse$templates$proxyviews__calculator$$default
} from "./discourse/templates/proxyviews-calculator";
import * as Mod26 from "./discourse/templates/proxyviews-compare";
compatModules["discourse/templates/proxyviews-compare"] = Mod26;

export * as discourse$templates$proxyviews__compare$$__module from "./discourse/templates/proxyviews-compare";
export {
default as discourse$templates$proxyviews__compare$$default
} from "./discourse/templates/proxyviews-compare";
import * as Mod27 from "./discourse/templates/proxyviews-directory";
compatModules["discourse/templates/proxyviews-directory"] = Mod27;

export * as discourse$templates$proxyviews__directory$$__module from "./discourse/templates/proxyviews-directory";
export {
default as discourse$templates$proxyviews__directory$$default
} from "./discourse/templates/proxyviews-directory";
import * as Mod28 from "./discourse/templates/proxyviews-methodology";
compatModules["discourse/templates/proxyviews-methodology"] = Mod28;

export * as discourse$templates$proxyviews__methodology$$__module from "./discourse/templates/proxyviews-methodology";
export {
default as discourse$templates$proxyviews__methodology$$default
} from "./discourse/templates/proxyviews-methodology";
import * as Mod29 from "./discourse/templates/proxyviews-provider";
compatModules["discourse/templates/proxyviews-provider"] = Mod29;

export * as discourse$templates$proxyviews__provider$$__module from "./discourse/templates/proxyviews-provider";
export {
default as discourse$templates$proxyviews__provider$$default
} from "./discourse/templates/proxyviews-provider";
import * as Mod30 from "./discourse/templates/proxyviews-vendor-dashboard";
compatModules["discourse/templates/proxyviews-vendor-dashboard"] = Mod30;

export * as discourse$templates$proxyviews__vendor__dashboard$$__module from "./discourse/templates/proxyviews-vendor-dashboard";
export {
default as discourse$templates$proxyviews__vendor__dashboard$$default
} from "./discourse/templates/proxyviews-vendor-dashboard";
export default compatModules;
